import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const formatStartDate = (startDate: string) => {
    const date = new Date(startDate)
    return format(date, "dd 'de' MMMM", {
        locale: ptBR,
    })
}
